import React, { useState, useEffect } from "react";

//ANT DESIGN IMPORTS
import {
  Input,
  Row,
  Typography,
  Form,
  Col,
  Divider,
  Card,
  Table
} from "antd";

import appLabel from "../../../../../config/appLabel";

const { Text, Title } = Typography;

const columnsOne = [
  {
    title: "Payment Type",
    dataIndex: "paymentType",
  },
  {
    title: "Fund Source",
    dataIndex: "fundSource",
  },
];

const columnsTwo = [
  {
    title: "Fees",
    dataIndex: "fees",
  },
  {
    title: "Income Account",
    dataIndex: "incomeAccount",
  },
];

const columnsThree = [
  {
    title: "Penalty",
    dataIndex: "penalty",
  },
  {
    title: "Income Account",
    dataIndex: "incomeAccountPenalty",
  },
];

export default function AccountingForm({ redeDetail }) {
  const [accountDetailOne, setAccountDetailOne] = useState([]);
  const [accountDetailTwo, setAccountDetailTwo] = useState([]);
  const [accountDetailThree, setAccountDetailThree] = useState([]);

  useEffect(() => {
    let tempArrayOne = [];
    let tempArrayTwo = [];
    let tempArrayThree = [];

    const fundSourcesforPaymentChannels =
      redeDetail?.paymentChannelToFundSourceMappings
        ? redeDetail?.paymentChannelToFundSourceMappings
        : ["-"];
    fundSourcesforPaymentChannels.forEach((element) => {
      tempArrayOne.push({
        key: element?.id,
        paymentType: element?.paymentType?.name
          ? element?.paymentType?.name
          : "-",
        fundSource: element?.fundSourceAccount?.name
          ? element?.fundSourceAccount?.name
          : "-",
      });
    });

    const feestoSpecificIncomeAccount = redeDetail?.feeToIncomeAccountMappings
      ? redeDetail?.feeToIncomeAccountMappings
      : ["-"];

    feestoSpecificIncomeAccount.forEach((element) => {
      tempArrayTwo.push({
        key: element?.id,
        fees: element?.charge?.name ? element?.charge?.name : "-",
        incomeAccount: element?.incomeAccount?.name
          ? element?.incomeAccount?.name
          : "-",
      });
    });

    const penaltiestoSpecificIncomeAccount =
      redeDetail?.penaltyToIncomeAccountMappings
        ? redeDetail?.penaltyToIncomeAccountMappings
        : ["-"];

    penaltiestoSpecificIncomeAccount.forEach((element) => {
      tempArrayThree.push({
        key: element?.id,
        penalty: element?.charge?.name ? element?.charge?.name : "-",
        incomeAccountPenalty: element?.incomeAccount?.name
          ? element?.incomeAccount?.name
          : "-",
      });
    });
    setAccountDetailOne(tempArrayOne);
    setAccountDetailTwo(tempArrayTwo);
    setAccountDetailThree(tempArrayThree);
  }, []);

  const [useForm] = Form.useForm();

  return (
    <Form layout="vertical" form={useForm}>
      <Card
        style={{
          marginBottom: "2%",
          boxShadow: "0px 0px 30px 5px rgba(0,0,0,0.025)",
          padding: 10,
        }}
      >
        <Divider orientation="left" orientationMargin="0">
          <Title level={5} style={{ margin: 0, marginBottom: 0 }}>
            {"  Assets"}
          </Title>
        </Divider>
        <Row>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.depositReference}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  redeDetail?.accountingMappings?.savingsReferenceAccount?.name
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Title level={4} style={{ margin: 0 }}>
            Liabilities
          </Title>
          <Divider />
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.depositControl}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  redeDetail?.accountingMappings?.savingsControlAccount?.name
                }
              ></Input>
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.transfersInSupense}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  redeDetail?.accountingMappings?.transfersInSuspenseAccount?.name
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Title level={4} style={{ margin: 0 }}>
            Expenses
          </Title>
          <Divider />
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.interestOnDeposit}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  redeDetail?.accountingMappings?.interestOnSavingsAccount?.name
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Row>
          <Title level={4} style={{ margin: 0 }}>
            Income
          </Title>
          <Divider />
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.incomeFromFee}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={redeDetail?.accountingMappings?.incomeFromFeeAccount?.name}
              />
            </Form.Item>
          </Col>
          <Col span={12} style={{ padding: "0px 8px" }}>
            <Form.Item label={<Text>{appLabel.incomeFromPenalties}</Text>}>
              <Input
                className="of-bold-disable-input"
                disabled
                value={
                  redeDetail?.accountingMappings?.incomeFromPenaltyAccount?.name
                }
              />
            </Form.Item>
          </Col>
        </Row>
        <Title level={4} style={{ margin: 0 }}>
          Advanced Accounting Rule
        </Title>
        <Divider />
        <Table
          columns={columnsOne}
          dataSource={accountDetailOne}
          bordered
          title={(e) => "Configure Fund Sources for Payment Channels"}
          pagination={{
            position: "bottomCentre",
          }}
        />
        <Table
          columns={columnsTwo}
          dataSource={accountDetailTwo}
          bordered
          title={(e) => "Fees to Specific Income Account"}
          pagination={{
            position: "bottomCentre",
          }}
        />
        <Table
          columns={columnsThree}
          dataSource={accountDetailThree}
          bordered
          title={(e) => "Penalties to Specific Income Account"}
          pagination={{
            position: "bottomCentre",
          }}
        />
      </Card>
    </Form>
  );
}
